<template>
<div>
  	<top-header></top-header>
	<main-menu></main-menu>
	<!-- Start the code for this screen here -->
  	<div class="pagecontainer container">
		<div >
		<div class="heading"><span><b>Assigned Dealers</b></span></div>
		<div>
			<center>
      		<table id="dealerassignments" class="table-month-table">
				<tr>
					<th class="center table-month-header-blue "  v-for="(dach,index) in dealerassignmentcolnames" :key="index"
					v-if="dach.value != 'Action' && dach.value != 'SI.No'" >{{ dach.value }}</th>
				</tr>
				<tr v-for="(entry,index) of sortedDealers" :key="index" class="table-month-row ">
					<td class="center table-month-td ">{{entry.selectedRegionX}}</td>
					<td class="center table-month-td ">{{entry.selectedStateX}}</td>
					<td class="center table-month-td ">{{entry.selectedDealerX}}</td>
				</tr>
			</table></center>

		<br>

				</div>
			<br><br>
		</div>
	</div>
  	<!-- End of the code for this screen here -->
   <bottom-footer></bottom-footer>
  </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import dealersjson from '../json/assigneddealers.json'
import httpemployee from '../js/http-employee.js'
import httpcommon from '../js/http-common.js'
export default {
  components: {
    MainMenu,
    TopHeader,
    BottomFooter
  },
  data () {
    return {
      assigneddealers: dealersjson,
      dealerassignmentcolnames: [],
      reviewlist: []
    }
  },
  methods: {
    fetchData () {
      httpcommon.get('/staticdata/dacolumnnames/').then(response => { this.dealerassignmentcolnames = response.data }).catch(e => { this.errorslist.push(e) })
      if (this.$session.get('user_role') == 'SR') {
        this.displaySpecialAgentSection()
      }
    },
    displaySpecialAgentSection: function () {
      this.reviewlist = []
      httpemployee.get('/employee/' + parseInt(this.$session.get('employee_id'))).then(response => {
					 for (var i = 0; i < response.data.length; i++) {
          var employeeobject = response.data[i]
          for (var i = 0; i < employeeobject.empBusinessCoverageAreas.length; i++) {
            var empbuscovarea = employeeobject.empBusinessCoverageAreas[i]
            this.reviewlist.push({
              'selectedRegionX': empbuscovarea.dregion.regionX,
              'selectedStateX': empbuscovarea.dstateFip.stateN,
              'selectedDealerX': empbuscovarea.ddealerInfo.dealerName
            })
          }
        }
      }).catch(e => { console.log(e) })
    }
  },
  mounted () {
    this.fetchData()
  },
  computed: {
    sortedDealers: function () {
      return this.reviewlist.sort((a, b) => {
		 if (a.selectedRegionX > b.selectedRegionX) return 1
		 if (a.selectedRegionX < b.selectedRegionX) return -1
		 if (a.selectedStateX > b.selectedStateX) return 1
		 if (a.selectedStateX < b.selectedStateX) return -1
		 if (a.selectedDealerX > b.selectedDealerX) return 1
		 if (a.selectedDealerX < b.selectedDealerX) return -1
		 })
    }
  }
}
</script>
<style scoped>
</style>
